<template>
  <v-navigation-drawer
    id="AppDrawer"
    v-model="drawer"
    :mini-variant="mini"
    permanent
    app
    clipped
    width="370"
    mini-variant-width="80"
  >
    <v-list-item two-line>
      <v-hover>
        <template v-slot:default="{ hover }">
          <v-list-item-avatar
            style="width: 60px!important;min-width: 60px !important;height: 60px!important;"
          >
            <img
              v-bind:src="userImage"
              style="border-style: solid;border-width: thin;border-color: #DCDCDC;width: 60px!important;height: 60px!important;"
            />
            <v-fade-transition>
              <v-overlay v-if="hover" absolute color="#DCDCDC">
                <v-btn
                  color="#DCDCDC"
                  icon
                  text
                  @click="
                    $refs.inputUpload.click();
                    alertImage();
                  "
                >
                  <v-icon>mdi-camera</v-icon>
                </v-btn>
                <input
                  v-show="false"
                  ref="inputUpload"
                  type="file"
                  @change="previewImage"
                  accept="image/*"
                />
              </v-overlay>
            </v-fade-transition>
          </v-list-item-avatar>
        </template>
      </v-hover>

      <v-list-item-content>
        <v-list-item-title class="subtitle3Text" v-text="DealerName"></v-list-item-title>
        <v-list-item-subtitle class="regularText" v-text="userName"></v-list-item-subtitle>
        <v-list-item-subtitle class="regularText" v-text="Level"></v-list-item-subtitle>
      </v-list-item-content>

      <v-btn icon @click.stop="mini = !mini">
        <v-icon class="icon-size">mdi-chevron-left</v-icon>
      </v-btn>
    </v-list-item>

    <v-divider></v-divider>

    <v-list-item
      v-on:click="individualFuel()"
      :color="colorTheme"
      @click.stop
      link
      v-if="
          serviceListAlertFuelIn == true 
        "
    >
      <v-list-item-avatar>
        <img src="../assets/fuel-img.png" />
      </v-list-item-avatar>

      <v-list-item-content style="text-align: initial;">
        <v-list-item-title class="regularText">ALERTFUEL</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list dense>
      <v-list-group
        no-action
        v-model="active"
        v-if="mini == false && serviceListAlertruck == true"
        :color="colorTheme"
      >
        <template v-slot:activator>
          <v-list-item style="padding: 0; padding-right: 20px;" :color="colorTheme" link>
            <v-list-item-avatar>
              <img src="../assets/alerttruck-btn.png" />
            </v-list-item-avatar>

            <v-list-item-content style="text-align: initial;">
              <v-list-item-title class="regularText">{{ $t("tracts").toUpperCase() }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item
          v-for="item in itemsOptions"
          :key="item.title"
          :to="item.path == '#' ? '' : item.path"
          @click.stop="closeMini()"
          :color="colorTheme"
          :active-class="colorTheme"
        >
          <v-list-item-icon>
            <v-icon class="icon-size">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="regularText text-start">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-menu v-if="mini == true && serviceListAlertruck == true" open-on-hover offset-x>
        <template v-slot:activator="{ on }">
          <v-list-item link v-on="on" :color="colorTheme">
            <v-list-item-avatar>
              <img src="../assets/alerttruck-btn.png" />
            </v-list-item-avatar>

            <v-list-item-content style="text-align: initial;">
              <v-list-item-title class="regularText">{{ $t("tracts").toUpperCase() }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list>
          <v-list-item
            v-for="item in itemsOptions"
            :key="item.title"
            :to="item.path == '#' ? '' : item.path"
            @click.stop
            :color="colorTheme"
            :active-class="colorTheme"
          >
            <v-list-item-icon>
              <v-icon class="icon-size">{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="regularText">{{ item.title.toUpperCase() }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- NOTE: Tracking is deprecated -->
      <!-- <v-list-item
        v-on:click="tracking()"
        :color="colorTheme"
        @click.stop
        link
        v-if="
          serviceListTracking == true && this.$store.state.production == false
        "
      >
        <v-list-item-avatar>
          <img src="../assets/rastreo-g.png" />
        </v-list-item-avatar>

        <v-list-item-content style="text-align: initial;">
          <v-list-item-title class="regularText">{{ $t("tracking").toUpperCase() }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group
        no-action
        v-model="active2"
        v-if="mini == false && this.$store.state.production == false"
        :color="colorTheme"
      >
        <template v-slot:activator>
          <v-list-item style="padding: 0; padding-right: 20px;" :color="colorTheme" link>
            <v-list-item-avatar>
              <img src="../assets/Rutas-g2.png" />
            </v-list-item-avatar>

            <v-list-item-content style="text-align: initial;">
              <v-list-item-title class="regularText">{{ $t("traffic").toUpperCase() }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item
          v-for="item in itemsOptionsTraffic"
          :key="item.title"
          :to="item.path == '#' ? '' : item.path"
          @click.stop="closeMini()"
          :color="colorTheme"
          :active-class="colorTheme"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="regularText">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-menu v-if="mini == true && this.$store.state.production == false" open-on-hover offset-x>
        <template v-slot:activator="{ on }">
          <v-list-item link v-on="on" :color="colorTheme">
            <v-list-item-avatar>
              <img src="../assets/Rutas-g2.png" />
            </v-list-item-avatar>

            <v-list-item-content style="text-align: initial;">
              <v-list-item-title class="regularText">{{ $t("traffic").toUpperCase() }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list>
          <v-list-item
            v-for="item in itemsOptionsTraffic"
            :key="item.title"
            :to="item.path == '#' ? '' : item.path"
            @click.stop
            :color="colorTheme"
            :active-class="colorTheme"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="regularText">{{ item.title.toUpperCase() }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu> -->

      <v-list-item
        v-on:click="account()"
        :color="colorTheme"
        @click.stop
        link
        v-if="this.$store.state.SelectedAccess.Level == 'Master'"
      >
        <v-list-item-avatar>
          <img src="../assets/account-btn.png" />
        </v-list-item-avatar>

        <v-list-item-content style="text-align: initial;">
          <v-list-item-title class="regularText">{{ $t("accountM").toUpperCase() }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item :color="colorTheme" link v-on:click="logout()" @click.stop>
        <v-list-item-avatar>
          <img src="../assets/Group16.png" />
        </v-list-item-avatar>

        <v-list-item-content style="text-align: initial;">
          <v-list-item-title class="regularText">{{ $t("exit").toUpperCase() }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="subtitle2Text">{{ $t("logout").toUpperCase() }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="regularText" :color="colorTheme" text @click="dialog = false">{{ $t("cancel").toUpperCase() }}</v-btn>
          <v-btn
            class="regularText"
            :color="colorTheme"
            text
            @click="dialog = false"
            v-on:click="exitToapp()"
          >{{ $t("accept").toUpperCase() }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";

export default {
  name: "appDrawer",
  data() {
    return {
      drawer: true,
      right: null,
      dialog: false,
      userName: "",
      Level: "",
      DealerName: "",
      serviceListAlertruck: "",
      serviceListAlertFuelIn: "",
      serviceListTracking: ""
    };
  },
  created() {
    this.InforUser();
  },
  computed: {
    ...mapState([
      "itemsMenu",
      "itemsOptions",
      "itemsOptionsTraffic",
      "userData",
      "colorTheme",
      "userImage"
    ]),

    mini: {
      get: function() {
        return this.$store.state.mini;
      },
      set: function() {
        this.$store.commit("appDrawer");
      }
    },
    active: {
      get: function() {
        return this.$store.state.itemsMenu[0].active;
      },
      set: function() {}
    },
    active2: {
      get: function() {
        return this.$store.state.itemsMenu[1].active;
      },
      set: function() {}
    },
    marginProfile: {
      get: function() {
        if (this.$store.state.mini) return "";
        else return "margin-top: 15px;";
      },
      set: function() {}
    },
    marginList: {
      get: function() {
        if (this.$store.state.mini) return "";
        else return "margin-bottom: 15px;";
      },
      set: function() {}
    }
  },
  methods: {
    previewImage: function(event) {
      var input = event.target;
      if (input.files[0].size < 5242880) {
        var type = input.files[0].type.replace("image/", "");
        localStorage.setItem("typeImageUser", type);
        if (input.files && input.files[0]) {
          var reader = new FileReader();
          reader.onload = e => {
            //this.$store.commit("userImage", e.target.result);
            this.$store.dispatch("setPersonalization", [
              "userImage",
              e.target.result
            ]);
          };
          reader.readAsDataURL(input.files[0]);
        }
      } else {
        this.$store.commit("snackbar", {
          snackbar: true,
          text: i18n.t("alertImage")
        });
      }
    },
    alertImage() {
      this.$store.commit("snackbar", {
        snackbar: true,
        text: i18n.t("sizeImage"),
        x: "right"
      });
    },
    logout() {
      if (!this.$store.state.mini) this.$store.commit("appDrawer");
      this.dialog = true;
    },
    exitToapp() {
      this.$store.commit("readListOfReports", []);
      this.$store.commit("cancelMultipleAccess");
      this.$store.dispatch("logOutApp", null);
    },
    InforUser() {
      var SelectedAccess =
        this.$store.state.SelectedAccess != null
          ? this.$store.state.SelectedAccess
          : JSON.parse(localStorage.getItem("SelectedAccess"));
      this.userName =
        this.$store.state.userData.Email != null
          ? this.$store.state.userData.Email
          : localStorage.getItem("userName");
      this.Level = SelectedAccess.Level;
      this.DealerName =
        SelectedAccess.DealerName == null ||
        SelectedAccess.DealerName.length == 0
          ? this.$t("noName").toUpperCase()
          : SelectedAccess.DealerName;
      this.serviceListAlertruck = SelectedAccess.ServiceList.AlertTruck;
      this.serviceListAlertFuelIn =
        SelectedAccess.ServiceList.AlertFuel_Individual;
      this.serviceListTracking = SelectedAccess.ServiceList.Tracking;
    },
    closeMini() {
      this.$store.commit("appDrawer");
    },
    reportsPage() {
      if (!this.$store.state.mini) this.closeMini();
      this.$router.replace({ name: "reportsPage" });
    },
    account() {
      if (!this.$store.state.mini) this.closeMini();
      this.$router.replace({ name: "accountManager" });
    },
    individualFuel() {
      if (!this.$store.state.mini) this.closeMini();
      this.$router.replace({ name: "individualFuel" });
    },
    tracking() {
      if (!this.$store.state.mini) this.closeMini();
      this.$router.replace({ name: "tracking" });
    }
  }
};
</script>
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

body,
html {
  height: 100% !important;
  width: 100% !important;
  margin: 0;
  font: 400 15px/1.8 "Lato", sans-serif;
  color: #777;
}

.listUserData {
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}

.drawerTop {
  top: 48px;
}
</style>
